
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BaseArrow',
  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
    length: {
      type: String,
      required: true,
    },
    dotted: {
      type: Boolean,
      default: false,
    },
  },
});
